import React from 'react';
import styled from 'styled-components';
import * as Sentry from '@sentry/react';
import Box from '../../styledComponents/Box';
import logo from '../../assets/logo.png';
import LinkButton from '../../styledComponents/LinkButton';

const StyledGrid = styled.div`
  height: 100vh;
  display: grid;
  grid-template-columns: auto auto auto;
  margin-left: 10px;
  margin-right: 10px;
`;

const StyledContent = styled(Box)`
  justify-self: center;
  align-self: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-left: 10px;
  margin-right: 10px;
  padding-bottom: 30px;
  padding-left: 10px;
  padding-top: 30px;
  padding-right: 10px;

  @media (min-width: 600px) {
    padding-left: 40px;
    padding-right: 40px;
    width: 450px;
    max-width: 450px;
  }
`;

const ErrorPage = ({ eventId }) => {
  return (
    <StyledGrid>
      <div />
      <StyledContent>
        <div>
          <img src={logo} alt='Logo' />
        </div>

        <p>
          Bei dem Versuch, die Seite zu laden, ist ein Fehler aufgetreten.
          Möglicherweise gibt es ein Problem mit der Verbindung. Klicke{' '}
          <LinkButton
            onClick={() => {
              window.location.replace('/');
            }}>
            hier
          </LinkButton>{' '}
          , um die Seite neu zu laden. Sollte das Problem weiterhin bestehen,
          kannst du uns eine
          <LinkButton
            onClick={() => {
              Sentry.showReportDialog({ eventId, lang: 'de' });
            }}>
            {' '}
            Nachricht
          </LinkButton>{' '}
          zukommen lassen.
        </p>
      </StyledContent>
      <div />
    </StyledGrid>
  );
};

export default ErrorPage;
